import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { TransitProgramInfo } from './transit-program-info';
import { OrganizationPaymentMethod } from './organization-payment-method';
import { PaymentAccount } from './payment-account';
import { PaymentCollectionType } from './payment-collection-type';
import { RiderFeeDetail } from './rider-fee-detail';
import { TripListItem } from './trip-list-item';
import { isNullOrUndefined } from '@uzurv/rideWss/app/util';
import { RideReview } from './ride-review';

@inheritSerialization(TripListItem)
export class TripDetail extends TripListItem {
  @autoserialize
  polyline: string;

  @autoserialize
  passengerCount: number;

  @autoserialize
  billablePassengerCount: number;

  @autoserialize
  riderNote: string;

  @autoserializeAs(Date)
  estimatedTimeOfArrival: Date;

  @autoserialize
  executionPlatform: string;

  @autoserialize
  cancellationReason: string;

  @autoserializeAs(PaymentCollectionType)
  riderPaymentCollectionType: PaymentCollectionType;

  @autoserialize
  driverName: string;

  @autoserialize
  driverProfilePictureUrl: string;

  @autoserialize
  driverCurrentLatitude: number;

  @autoserialize
  driverCurrentLongitude: number;

  @autoserialize
  vehicleMake: string;

  @autoserialize
  vehicleModel: string;

  @autoserialize
  vehicleYear: string;

  @autoserialize
  vehicleLicensePlateStateCode: string;

  @autoserialize
  vehicleLicensePlate: string;

  @autoserialize
  vehicleColor: string;

  @autoserialize
  vehicleImageUrl: string;

  @autoserializeAs(Date)
  driverEnRouteAt: Date;

  @autoserializeAs(Date)
  pickupArrivedAt: Date;

  @autoserializeAs(Date)
  inProgressAt: Date;

  @autoserializeAs(Date)
  completedAt: Date;

  @autoserializeAs(Date)
  cancelledAt: Date;

  @autoserializeAs(TransitProgramInfo)
  transitProgramInfo: TransitProgramInfo;

  @autoserializeAs(OrganizationPaymentMethod)
  supportedPaymentMethods: Array<OrganizationPaymentMethod>;

  @autoserialize
  paymentMethodId: number;

  @autoserializeAs(RiderFeeDetail)
  riderFeeDetail: RiderFeeDetail;

  @autoserializeAs(PaymentAccount)
  riderPaymentAccount: PaymentAccount;

  @autoserializeAs(RideReview)
  rideReview: RideReview;

  static OnSerialized(instance: TripDetail, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.estimatedTimeOfArrival)) {
      json.estimatedTimeOfArrival = instance.estimatedTimeOfArrival.getTime();
    }

    if (!isNullOrUndefined(instance.driverEnRouteAt)) {
      json.driverEnRouteAt = instance.driverEnRouteAt.getTime();
    }

    if (!isNullOrUndefined(instance.pickupArrivedAt)) {
      json.pickupArrivedAt = instance.pickupArrivedAt.getTime();
    }

    if (!isNullOrUndefined(instance.inProgressAt)) {
      json.inProgressAt = instance.inProgressAt.getTime();
    }

    if (!isNullOrUndefined(instance.completedAt)) {
      json.completedAt = instance.completedAt.getTime();
    }
    if (!isNullOrUndefined(instance.cancelledAt)) {
      json.cancelledAt = instance.cancelledAt.getTime();
    }
  }

  static OnDeserialized(instance: TripDetail, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['estimatedTimeOfArrival'])) {
      instance.estimatedTimeOfArrival = new Date(json['estimatedTimeOfArrival']);
    }

    if (!isNullOrUndefined(json['driverEnRouteAt'])) {
      instance.driverEnRouteAt = new Date(json['driverEnRouteAt']);
    }

    if (!isNullOrUndefined(json['pickupArrivedAt'])) {
      instance.pickupArrivedAt = new Date(json['pickupArrivedAt']);
    }

    if (!isNullOrUndefined(json['inProgressAt'])) {
      instance.inProgressAt = new Date(json['inProgressAt']);
    }

    if (!isNullOrUndefined(json['completedAt'])) {
      instance.completedAt = new Date(json['completedAt']);
    }

    if (!isNullOrUndefined(json['cancelledAt'])) {
      instance.cancelledAt = new Date(json['cancelledAt']);
    }
  }
}
